import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import * as RolService from 'services/rol.service'

import NuevoMainForm from './mainForm'

import { IdGen } from 'utils'

const RolesNuevoPage = ({ match }) => {
  const __zariContext = React.useContext(ZariContext)

  const [__keyMainForm, setKeyMainForm] = React.useState(null)

  const editarDataRef = React.useRef({})

  const portletBreadcrumbs = React.useMemo(() => {
    if (match.params.id) {
      return [{ name: 'Roles', path: `/${CodigosTransaccionesConstant.ROLES_LISTA}` }, { name: 'Editar' }]
    }
    return [{ name: 'Roles', path: `/${CodigosTransaccionesConstant.ROLES_LISTA}` }, { name: 'Nuevo' }]
  }, [match.params.id])

  React.useEffect(() => {
    if (match.params.id) {
      RolService.getRol(match.params.id)
        .then(({ data }) => {
          editarDataRef.current = data
          setKeyMainForm(IdGen.newId())
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      setKeyMainForm(IdGen.newId())
    }
  }, [match.params, __zariContext])

  return (
    <Portlet>
      <Portlet.Header title='ROLES' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>{__keyMainForm && <NuevoMainForm key={__keyMainForm} editarData={editarDataRef.current} />}</Portlet.Body>
    </Portlet>
  )
}

export default RolesNuevoPage
